
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [isLoaded, setIsLoaded] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const scrollToNext = () => {
    const element = document.getElementById('story');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/213c0d14940852ce0db385d6e9b05863.jfif')`
        }}
      >
        <div className="absolute inset-0 bg-white/40"></div>
      </div>

      {/* Content */}
      <div className={`relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 transition-all duration-1000 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="w-full flex items-center min-h-[80vh]">
          <div className="w-full lg:w-1/2 space-y-8">
            <h1 
              className="text-xl sm:text-2xl lg:text-4xl font-bold text-[#2A2A2A] leading-loose"
              style={{ fontFamily: 'Playfair Display, Noto Serif SC, serif' }}
            >
              {t('hero_title')}
              <br />
              <span className="text-[#A6A6A6]">{t('hero_title_highlight')}</span>
            </h1>
            
            <p 
              className="text-xs sm:text-xs lg:text-base text-[#2A2A2A] leading-relaxed max-w-2xl"
              style={{ fontFamily: 'Inter, Noto Sans SC, sans-serif' }}
            >
              {t('hero_description')}
            </p>
            
            <div className="pt-4">
              <Button 
                size="lg" 
                onClick={() => document.getElementById('newsletter')?.scrollIntoView({ behavior: 'smooth' })}
                className="text-xs sm:text-xs px-6 py-3"
              >
                {t('hero_cta')}
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <button 
          onClick={scrollToNext}
          className="w-4 h-4 flex items-center justify-center cursor-pointer animate-bounce"
        >
          <i className="ri-arrow-down-line text-xs text-[#2A2A2A]"></i>
        </button>
      </div>
    </section>
  );
}
